<template>
	<aside class="main" v-if="ready && date && time">
		<div class="content">
			<label class="date">{{ date }}</label>
			<label class="time">{{ time }}</label>
		</div>
	</aside>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Services from '../mixins/services';
	import moment from "moment";

	export default {
		mixins: [Services],
		props: ['clinicId'],
		components: {
		},
		data: function () {
			return {
				ready: false,
				date: null,
				time: null
			}
		},
        computed: mapState({
			clientToken: state => state.ClientToken.clientToken,
			nextAvailableAppointment: state => state.NextAvailable.nextAvailableAppointment,
		}),
		methods: {
			...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
			...mapActions('NextAvailable', { getInformation: 'getInformation' }),
		},
		mounted() {
			
		},
		created() {
			this.getClientToken({
				cb: () => {
					this.getInformation({
						ClinicId: this.clinicId,
						ClientToken: this.clientToken,
						cb: () => {
							if (this.nextAvailableAppointment !== '0001-01-01T00:00:00') {
								this.date = moment(this.nextAvailableAppointment).format("dddd MMM. Do");
								this.time = moment(this.nextAvailableAppointment).format("h:mm A");
								document.getElementsByTagName("body")[0].style.background = 'transparent';
								this.ready = true;
							}
						}
					});
          setInterval(() => {
            let height = $('body').outerHeight(); // IMPORTANT: If body's height is set to 100% with CSS this will not work.
            parent.postMessage("resize::nextAvailable" + height, "*");
          }, 1000);
				}
			})
		}
    }
</script>